import axios from "axios";

import sar_for_white_theme from "../src/images/sar_for_white_theme.svg";
import sar_for_dark_theme from "../src/images/sar_for_dark_theme.svg";

export const FCM_TOKEN = "emrDNE9HT6CPp4zLHNud2D:APA91bG38qZDtmago4BR75an7y90JWZmcFLxZCzg_Jlk9ryO5pAbaMLzC2AUyLcNwYdlQnnaOeWIPBG0whyUnUUdMnYnM5cHa_OHgdz_gcchW8xQZP8bjkg";

export const GetTextFontByLang = ($type) => {
  const language = localStorage.getItem("lang");

  if (language === "ar" || language === "fa") {
    if ($type === "h") {
      return "lang_ar_head";
    } else if ($type === "s") {
      return "lang_ar_sub";
    } else {
      return "";
    }
  } else {
    if ($type === "h") {
      return "lang_head";
    } else if ($type === "s") {
      return "lang_sub";
    } else {
      return "";
    }
  }
};

export const SetTextAlignByLang = () => {
  const language = localStorage.getItem("lang");
  if (language === "ar" || language === "fa") {
    return "rtl text-end";
  } else {
    return "ltr text-start";
  }
};

export const SetPrimaryBackgroundByMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "dark-mode-primary-background";
  } else {
    return "primary-background";
  }
};

export const SetSecondryBackgroundByMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "dark-mode-secandory-background";
  } else {
    return "secondary-background";
  }
};

export const SetThirdBackgroundByMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "dark-mode-third-background";
  } else {
    return "gray-background";
  }
};

export const SetPrimaryColorByMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "primary-color";
  } else {
    return "dark-color";
  }
};

export const SetSecondryColorByMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "gray-color";
  } else {
    return "secondary-color";
  }
};

export const setMode = () => {
  const mode = localStorage.getItem("mode");
  if (mode === "dark") {
    return "dark";
  } else {
    return "light";
  }
};
export const setLang = () => {
  const lang = localStorage.getItem("lang");
  if (lang === "ar" || lang === "fa") {
    return "arabic-font";
  } else {
    return "latino-font";
  }
};

export const setMobileTextColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#E0E1DD";
  } else if (theme === "light") {
    return "#041731";
  } else if (theme === "costomize") {
    return localStorage.getItem("textColor");
  } else {
    return "#041731";
  }
};

export const setMobileSubTextColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#426CA5";
  } else if (theme === "light") {
    return "#426CA5";
  } else if (theme === "costomize") {
    return localStorage.getItem("textColor");
  } else {
    return "#426CA5";
  }
};

export const setMobileBackColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#000205";
  } else if (theme === "light") {
    return "#F2F4F7";
  } else if (theme === "costomize") {
    return localStorage.getItem("backColor");
  } else {
    return "#F2F4F7";
  }
};

export const setMobileCardColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#020E1D";
  } else if (theme === "light") {
    return "#F0F6FE";
  } else if (theme === "costomize") {
    return localStorage.getItem("cardColor");
  } else {
    return "#F0F6FE";
  }
};

export const setMobileCardBorderColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#6BA5F2";
  } else if (theme === "light") {
    return "#6BA5F2";
  } else if (theme === "costomize") {
    return localStorage.getItem("cardColor");
  } else {
    return "#6BA5F2";
  }
};

export const setMobileTextField_BK_FONT_Border_StyleColor = () => {
  //bgc - color - bordercolor
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return ["#020E1D", "#E0E1DD", "#D0D5DD"];
  } else if (theme === "light") {
    return ["#F9FAFB", "#98A2B3", "#D0D5DD"];
  } else if (theme === "costomize") {
    return [
      localStorage.getItem("cardColor"),
      localStorage.getItem("textColor"),
      "#D0D5DD",
    ];
  } else {
    return ["#f2f2f2", "#98A2B3"];
  }
};

export const setMobileButttonBackColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return "#6ba5f2";
  } else if (theme === "light") {
    return "#6ba5f2";
  } else if (theme === "costomize") {
    return localStorage.getItem("highlights");
  } else {
    return "#6ba5f2";
  }
};

export const getBadgeStatusClass = (status_name) => {
  const theme_type = localStorage.getItem("theme");
  var class_name =
    theme_type === "dark" ? "new-badge-style-dark" : "new-badge-style";
  if (status_name === "Excellent preparation on the table") {
    class_name =
      theme_type === "dark"
        ? "excellent-badge-style-dark"
        : "excellent-badge-style";
  } else if (status_name === "Chef's Specialty") {
    class_name =
      theme_type === "dark" ? "chef-badge-style-dark" : "chef-badge-style";
  } else if (status_name === "Most Ordered") {
    class_name =
      theme_type === "dark"
        ? "mostordered-badge-style-dark"
        : "mostordered-badge-style";
  } else if (status_name === "Suitable for diabetic patients") {
    class_name =
      theme_type === "dark"
        ? "suitable-badge-style-dark"
        : "suitable-badge-style";
  } else if (status_name === "Preferred for kids") {
    class_name =
      theme_type === "dark" ? "new-badge-style-dark" : "new-badge-style";
  } else if (status_name === "Most ordered among BBQs") {
    class_name =
      theme_type === "dark"
        ? "mostordered-badge-style-dark"
        : "mostordered-badge-style";
  }
  return class_name;
};

export const getOrderBadgeStatusClass = (status_name) => {
  const theme_type = localStorage.getItem("theme");
  var class_name = "";
  if (status_name === "cancelled") {
    class_name =
      theme_type === "dark"
        ? "cancelled-badge-style-dark"
        : "cancelled-badge-style";
  } else if (status_name === "ready") {
    class_name =
      theme_type === "dark" ? "ready-badge-style-dark" : "ready-badge-style";
  } else if (status_name === "delivered") {
    class_name =
      theme_type === "dark"
        ? "delivered-badge-style-dark"
        : "delivered-badge-style";
  } else if (status_name === "waiting") {
    class_name =
      theme_type === "dark"
        ? "waiting-badge-style-dark"
        : "waiting-badge-style";
  } else if (status_name === "preparing") {
    class_name =
      theme_type === "dark"
        ? "preparing-badge-style-dark"
        : "preparing-badge-style";
  } else if (status_name === "at delivery") {
    class_name =
      theme_type === "dark"
        ? "at_delivery-badge-style-dark"
        : "at_delivery-badge-style";
  }
  return class_name;
};

export const buildTree = (data, parentId) => {
  const children = data.filter((item) => item.parent_id === parentId);
  return children.map((child) => ({
    ...child,
    children: buildTree(data, child.id),
  }));
};

export const sortByPosition = () => {
  return function (elem1, elem2) {
    if (elem1.position < elem2.position) {
      return -1;
    } else if (elem1.position > elem2.position) {
      return 1;
    } else {
      return 0;
    }
  };
};

export const generateRandomToken = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    token += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return token;
};

export const AllLanguagesNames = (lang) => {
  const languages = [
    { ar: "Arabic" },
    { en: "English" },
    { fr: "French" },
    { "zh-Hans": "Chinese" },
    { ca: "Catalan" },
    { hr: "Croatian" },
    { cs: "Czech" },
    { da: "Danish" },
    { nl: "Dutch" },
    { et: "Estonian" },
    { de: "German" },
    { hu: "Hungarian" },
    { it: "Italian" },
    { mk: "Macedonian" },
    { nb: "Norwegian" },
    { fa: "Persian" },
    { pt: "Portuguese-br" },
    { "pt-pt": "Portuguese-pt" },
    { ro: "Romanian" },
    { ru: "Russian" },
    { ja: "Japanese" },
    { ko: "Korean" },
    { es: "Spanish" },
    { tr: "Turkish" },
    { uk: "Ukranian" },
    { sv: "Swedish" },
  ];

  const selected = languages.filter((language) => {
    return language[lang];
  });

  if (selected[0]) {
    return selected[0][lang];
  }
};

export const AllLanguagesCode = [
  "ja",
  "ko",
  "ar",
  "en",
  "az",
  "ca",
  "zh-Hans",
  "hr",
  "cs",
  "da",
  "nl",
  "et",
  "fa",
  "fr",
  "de",
  "he",
  "hu",
  "it",
  "mk",
  "nb",
  "pt",
  "pt-pt",
  "ro",
  "ru",
  "es",
  "sv",
  "tr",
  "uk",
];

export const languagesOptions = [
  { code: "ar", label: "Arabic" },
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "zh-Hans", label: "Chinese" },
  { code: "ca", label: "Catalan" },
  { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" },
  { code: "da", label: "Danish" },
  { code: "nl", label: "Dutch" },
  { code: "et", label: "Estonian" },
  { code: "de", label: "German" },
  { code: "hu", label: "Hungarian" },
  { code: "it", label: "Italian" },
  { code: "mk", label: "Macedonian" },
  { code: "nb", label: "Norwegian" },
  { code: "fa", label: "Persian" },
  { code: "pt", label: "Portuguese-br" },
  { code: "pt-pt", label: "Portuguese-pt" },
  { code: "ro", label: "Romanian" },
  { code: "ru", label: "Russian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "es", label: "Spanish" },
  { code: "tr", label: "Turkish" },
  { code: "uk", label: "Ukranian" },
  { code: "sv", label: "Swedish" },
];

export const getAndSaveTimeZone = async () => {
  try {
    const timeZone = localStorage.getItem("timezone");
    const countryCode = localStorage.getItem("countryCode");
    if (!timeZone || !countryCode) {
      const promise = await axios.get(`${process.env.REACT_APP_API}/timezone`);
      if (promise.status === 200) {
        const timezoneData = promise?.data?.data?.timezone
          ? promise?.data?.data?.timezone
          : "";

        localStorage.setItem("countryCode", JSON.stringify(promise?.data?.data?.countryCode));
        localStorage.setItem("timezone", JSON.stringify(timezoneData));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAuth = () => {
  const token = localStorage.getItem("jwt_authorization") || localStorage.getItem("authorization");
  const language = localStorage.getItem("lang");
  const venue_id = localStorage.getItem("venueId");
  const timeZone = localStorage.getItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      venueId: venue_id,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getAuthMobile = () => {
  const token = localStorage.getItem("mobileLoginToken");
  const language = localStorage.getItem("lang");
  const timeZone = localStorage.getItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getGustAuthMobile = () => {
  const token = localStorage.getItem("gustToken");
  const language = localStorage.getItem("lang");
  const timeZone = localStorage.getItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getAuthAdmin = () => {
  const token = localStorage.getItem("authorization");
  const language = localStorage.getItem("lang");
  const venue_id = localStorage.getItem("venueId");
  const timeZone = localStorage.getItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      venueId: venue_id,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getPopupBorderRaduis = () => "12px";

export const setMobileSettings = (p_details) => {
  if (!localStorage.getItem("showOption")) {
    localStorage.setItem(
      "showOption",
      p_details.mobile_settings?.showOption
    );
  }
  if (p_details.mobile_settings?.theme === "costomize") {
    localStorage.setItem(
      "theme",
      p_details.mobile_settings?.theme
    );
    localStorage.setItem(
      "textColor",
      p_details.mobile_settings.colorProps.text
    );
    localStorage.setItem(
      "backColor",
      p_details.mobile_settings.colorProps.back
    );
    localStorage.setItem(
      "cardColor",
      p_details.mobile_settings.colorProps.card
    );
    localStorage.setItem(
      "highlights",
      p_details.mobile_settings.colorProps.highlights
    );
  } else {
    if (
      localStorage.getItem("theme") !== "dark" &&
      localStorage.getItem("theme") !== "light"
    ) {
      localStorage.setItem(
        "theme",
        p_details.mobile_settings?.theme
      );
    }
  }
}



export const ISDARKTHEME = (theme, hexColor) => {
  if (theme === "dark") {
    return true;
  }

  if (theme === "light") {
    return false;
  }

  // Convert Hex to RGB
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  // Calculate Luminance
  const calculateLuminance = (r, g, b) => {
    const adjust = (channel) => {
      let c = channel / 255; // Normalize to [0, 1]
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const rLinear = adjust(r);
    const gLinear = adjust(g);
    const bLinear = adjust(b);

    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
  };

  // Get RGB from Hex
  const { r, g, b } = hexToRgb(hexColor);

  // Calculate Relative Luminance
  const luminance = calculateLuminance(r, g, b);

  // Determine Theme
  return luminance <= 0.5 ? true : false;
}


export const SARIconThemeColor = () => {
  const theme = localStorage.getItem("theme");
  if (theme === "dark") {
    return sar_for_dark_theme;
  } else {
    return sar_for_white_theme;
  }
};


export const sendNotificationFirebaseRes = async (detailsData, title, body, application_type) => {
  try {
    const params = new URLSearchParams(window.location.search);
    const response = await axios.post(
      `${process.env.REACT_APP_API}/send-firebase-notification`,
      {
        venue_id: detailsData?.venue_id,
        table_code: params.get("t") || "",
        title: title || "",
        body: body || "",
        application: application_type || "",
        gust_token: localStorage.getItem("gustToken"),
        data: {
          venue_id: detailsData?.venue_id,
          table: params.get("t") || "",
        },
      }
    );
    
    return response;
  } catch (error) {
    console.error("Error sending notification:", error);
  }
}


